import React from 'react';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const AttachmentMessageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});

export const AttachmentMessageChip = styled(({ isOutbound: _isOutbound, ...other }) => (
  <Chip {...other} />
))(({ theme, isOutbound }) => {
  const fileLabelColor = isOutbound ? theme.palette.brandColors.FPWhite : theme.palette.grey[900];
  const chipHoverColor = isOutbound ? theme.palette.primary.light : theme.palette.grey[100];

  return {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: theme.spacing(2.5, 1.5),
    borderRadius: '8px',
    backgroundColor: isOutbound ? theme.palette.primary.dark : theme.palette.grey[400],

    '& .MuiChip-label': {
      color: fileLabelColor,
      maxWidth: '240px'
    },

    '& .MuiChip-icon': {
      color: fileLabelColor
    },

    '&:hover': {
      backgroundColor: chipHoverColor
    },

    '&:focus': {
      backgroundColor: chipHoverColor
    }
  };
});

export const AttachmentSizeLabel = styled(({ isOutbound: _isOutbound, ...other }) => (
  <Typography {...other} />
))(({ theme, isOutbound }) => ({
  textAlign: isOutbound ? 'right' : 'left',
  color: isOutbound ? theme.palette.brandColors.FPWhite : theme.palette.grey[900],
  marginBottom: theme.spacing(1)
}));
